module.exports = __webpack_public_path__ + "img/the-netherlands-other-heart-diseases-male.ef658723.png";